import React, { useState } from "react";
import ReactExport from "react-data-export";
import { format } from "date-fns";
import { Button } from "../layer/wrapper";
import { getCurrentLocalDateTime } from "utils/getLocalDateTime";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function FirstYearBuro({
  loan = [],
  buroDate = new Date(),
  label = "",
  customDisabled = false,
}) {
  const [loading, setLoading] = useState(false);

  const onClickAging = async () => {
    try {
      // setLoading(true);
      const getExportId = document.getElementById("export-excel-ems");
      getExportId.click();
    } catch (error) {
      console.log("loading error", error);
    } finally {
      // setTimeout(() => {
      // }, loan.length * 1000);
      // setLoading(false);
    }
  };

  const getBase64FromUrl = async (url) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        resolve(base64data);
      };
    });
  };

  const createDataWithStyle = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    // console.log(
    //   "hello",
    //   await getBase64FromUrl(
    //     "https://images.pexels.com/photos/1103970/pexels-photo-1103970.jpeg"
    //   )
    // );

    for (let i = 0; i < data.length; i++) {
      var filled = { fgColor: { rgb: "FFFFFF" } };
      var filled_col_0 = { patternType: "solid", fgColor: { rgb: "FDFFA7" } };
      result.push([
        {
          value: `${data[i].loan_kbank_id || ""}`,
          style: { font: { sz: 14 }, alignment: "right", fill: filled_col_0 },
        },
        {
          value: data[i]?.fullname || "",
          style: { font: { sz: 14 }, alignment: "right" },
        },
        {
          value:
            data[i]?.addressCode +
              " " +
              data[i]?.addressDesc +
              " " +
              data[i]?.address || "",
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i]?.email || "",
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: ["", "2"].includes(data[i]?.letter) ? "จดหมาย" : "อีเมล",
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i]?.ems_first_buro || "",
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i]?.ems_year_buro || "",
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i]?.loan_status || "",
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        // {
        //   value: data[i]?.loan_status,
        //   style: {
        //     font: { sz: 14 },
        //     numFmt: "0,0.00",
        //     border: borders,
        //     alignment: "right",
        //     fill: filled,
        //   },
        // },
        {
          value:
            data[i]?.evidence?.length > 0
              ? getCurrentLocalDateTime(
                  new Date(
                    data[i]?.evidence[data[i]?.evidence.length - 1].paid_date
                  )
                ).fullDate
              : "-",
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
      ]);
    }
    return result;
  };

  const multiDataSet = [
    {
      columns: [
        {
          title: "job_no",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        }, //pixels width
        {
          title: "name",
          width: { wch: 30 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        }, //pixels width
        {
          title: "address",
          width: { wch: 80 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "4287f5" } } },
        }, //pixels width
        {
          title: "email",
          width: { wch: 40 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        }, //char width
        {
          title: "ประเภท",
          width: { wch: 20 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "EMS_First_Buro",
          width: { wch: 20 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "EMS_Year_Buro",
          width: { wch: 20 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "Status",
          width: { wch: 20 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "Last Payment Date",
          width: { wch: 20 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
      ],
      data: createDataWithStyle(loan),
    },
  ];

  return (
    <div>
      <ExcelFile
        filename={`EXPORT_EMS_${format(new Date(buroDate), "yyyy-MM-dd")}`}
        element={<button id="export-excel-ems" hidden></button>}
      >
        <ExcelSheet dataSet={multiDataSet} name="EMS"></ExcelSheet>
      </ExcelFile>
      <Button
        loading={loading}
        disabled={loading || !loan.length || customDisabled}
        onClick={onClickAging}
      >
        Export EMS {label}
      </Button>
    </div>
  );
}

export default FirstYearBuro;
